import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { OutboundLink } from "gatsby-plugin-google-analytics"

const getData = graphql`
  {
    info: site {
      siteMetadata {
        contact
      }
    }
  }
`

const PrivacyPage = () => (
  <StaticQuery
    query={getData}
    render={data => {
      const contact = data.info.siteMetadata.contact
      return (
        <Layout>
          <SEO
            title="Privacy Policy"
            description="Privacy policy for 918kiss-official.app: this site collects no personal data itself, runs Google Analytics via Google Tag Manager, and tracks outbound link clicks."
            pagePath="/privacy/"
          />
          <div className="container">
            <div className="row">
              <div className="col-12 pt-4 appbox-copy px-3 pb-3 mb-2">
                <h1 className="h3 block-title">Privacy Policy</h1>
                <p>
                  This policy explains what 918kiss-official.app collects when
                  you visit this site, and what it does not collect.
                </p>
                <h2 className="h5 block-title">
                  What this site does not collect
                </h2>
                <p>
                  This site does not require an account and does not ask for
                  your name, email address, or any other personal details. It
                  does not take deposits or process payments &mdash; anything
                  you pay for is handled inside the 918Kiss app, not on this
                  website.
                </p>
                <h2 className="h5 block-title">Analytics on this site</h2>
                <p>
                  This site uses Google Analytics, managed through Google Tag
                  Manager. When you visit, these tools may use cookies and
                  collect usage data such as the pages you view and the links
                  you click, in accordance with Google&rsquo;s own privacy
                  policies. You can opt out of Google Analytics at any time
                  using Google&rsquo;s Analytics opt-out page.
                </p>
                <h2 className="h5 block-title">Outbound links</h2>
                <p>
                  When you tap a download button or the WhatsApp contact button,
                  you leave this site for a third-party destination (a download
                  host or WhatsApp). We record that you clicked the link so we
                  can keep the links working; from that point on, the
                  destination service&rsquo;s own privacy practices apply.
                </p>
                <h2 className="h5 block-title">The 918Kiss app</h2>
                <p>
                  Once the 918Kiss app is installed, anything about your
                  account, deposits, or gameplay is handled by the 918Kiss app
                  under its own policies, not by this website. This site has no
                  access to what you do inside the app.
                </p>
                <h2 className="h5 block-title">Contact</h2>
                <p className="pb-2">
                  Questions about this policy? Message us on{" "}
                  <OutboundLink href={contact} className="link">
                    WhatsApp
                  </OutboundLink>{" "}
                  and our support team will reply.
                </p>
                <p className="pb-2 small">
                  <Link to="/">Back to home</Link>
                  {` · `}
                  <Link to="/terms/">Terms of Use</Link>
                  {` · `}
                  <Link to="/responsible-gaming/">Responsible Gaming</Link>
                </p>
              </div>
            </div>
          </div>
        </Layout>
      )
    }}
  />
)

export default PrivacyPage
